import React, { FC, useMemo } from 'react';
import styled from 'styled-components/native';

import dynamicSize from '@webtrader/core/dynamic-size';
import { useAuthWithKeys } from '@webtrader/core/services/auth';
import { useCompany } from '@webtrader/core/services/company';
import { validateCompanyAccess } from '@webtrader/core/validators/company';

import ExperienceDemoCreation from './ExperienceDemoCreation';
import ExperienceResetPassword from './ExperienceResetPassword';

interface IMiscProps {
  setNeedUpdateFields?: (value: boolean) => void;
}

const ExperienceDemo: FC<IMiscProps> = (props) => {
  const { company } = useCompany();

  const { loginErrorCode } = useAuthWithKeys(['loginErrorCode']);

  const { setNeedUpdateFields } = props;

  const { hasDemoAccountCreation } = useMemo(() => {
    return validateCompanyAccess(company);
  }, [company]);

  return (
    <>
      <ExperienceResetPassword setNeedUpdateFields={setNeedUpdateFields} />
      {loginErrorCode && hasDemoAccountCreation && (
        <>
          <MiscDivider />
          <ExperienceDemoCreation loginErrorCode={loginErrorCode} setNeedUpdateFields={setNeedUpdateFields} />
        </>
      )}
    </>
  );
};

export default ExperienceDemo;

const MiscDivider = styled.View`
  height: 1px;
  margin: ${dynamicSize.convertSize(16)}px 0;

  background-color: ${({ theme }) => theme.colors.border[0]};
`;
